// Chess's client registry entry (see ../registry.ts and docs/games-contract.md).
// The views are the shared board-game views (../board) driven by chessUi.

import React from 'react';
import { Crown } from 'lucide-react';
import { BoardTableSet } from '../board/BoardTableSet';
import { BOARD_CHAIRS, BOARD_FOOTPRINT } from '../board/boardLayout';
import { BoardOverlay } from '../board/BoardOverlay';
import { BoardTable3D } from '../board/BoardTable3D';
import { BoardVRPanel } from '../board/BoardVRPanel';
import { chessUi, CHESS_RULES, CHESS_TUTORIAL, SEAT_NAMES } from './chessUi';
import type { GameClientDef, OverlayProps, Table3DProps, VRPanelProps } from '../types';

function ChessOverlay(props: OverlayProps) {
  return <BoardOverlay {...props} ui={chessUi} footer="Play a friend, or the computer." />;
}
function ChessTable3D(props: Table3DProps) {
  return <BoardTable3D {...props} ui={chessUi} />;
}
function ChessVRPanel(props: VRPanelProps) {
  return <BoardVRPanel {...props} ui={chessUi} />;
}

export const chessClient: GameClientDef = {
  kind: 'chess',
  label: 'Chess',
  blurb: 'Classic chess for 2 — play a friend or the computer, with optional clocks.',
  icon: Crown,
  glyph: '♞',
  category: 'table',
  minPlayers: 2,
  maxPlayers: 2,
  bots: true,
  seatNames: SEAT_NAMES,
  ranking: 'wins',
  chairs: BOARD_CHAIRS,
  footprint: BOARD_FOOTPRINT,
  Furniture: BoardTableSet,
  Table3D: ChessTable3D,
  Overlay: ChessOverlay,
  VRPanel: ChessVRPanel,
  rules: CHESS_RULES,
  tutorial: CHESS_TUTORIAL,
};
